import { useEffect, useState, RefObject } from "react";

export const useContainerHeight = <T extends HTMLElement>(ref: RefObject<T | null>) => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const updateWidth = () => {
      if (ref.current) {
        setHeight(ref.current.clientHeight);
      }
    };

    updateWidth();

    const observer = new ResizeObserver(updateWidth);
    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref]);

  return height;
};
